module.exports = __webpack_public_path__ + "img/ics_o_truck.a39df744.svg";